<template>
  <b-card class="bg-white rounded-xl px-4 eventss">
    <!-- <el-drawer
      :title="`${this.action} FFC Podcast`"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <div class="px-5 pt-4">
        <div class="mt-4">
          <label class="fsize16 text-dark font-semibold">First Name</label>
          <el-input
            placeholder="Please input"
            class="w-full"
            v-model="name"
          ></el-input>
        </div>
        <div class="mt-4">
          <label class="fsize16 text-dark font-semibold">Last Name</label>
          <el-input
            placeholder="Please input"
            class="w-full"
            v-model="name"
          ></el-input>
        </div>
        <div class="mt-4">
          <label class="fsize16 text-dark font-semibold">Phone Number</label>
          <el-input
            placeholder="Please input"
            class="w-full"
            v-model="name"
          ></el-input>
        </div>
        <div class="mt-4">
          <label class="fsize16 text-dark font-semibold"
            >How did you hear about the event</label
          >
          <el-input
            placeholder="Please input"
            class="w-full"
            v-model="name"
          ></el-input>
        </div>
        <div class="mt-5 flex justify-center">
          <base-button
            outline
            @click="action == 'Add' ? addPodcastData() : editPodcastData()"
            class="px-8 fsize14 py-2 mx-1"
            type="primary"
          >
            Submit
          </base-button>
        </div>
      </div>
    </el-drawer> -->

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">FFC Corporate Event Registration</h2>
      </div>
      <base-button outline class="px-6 py-1 mx-1" type="primary">
        <download-excel
          class="mr-1 flex"
          default-value=""
          :fetch="getAllData"
          :fields="json_fields"
          worksheet="My Worksheet"
          name="EventRegistrationfile.xls"
        >
          <span class="btn-inner--text flex justify-between items-center">
            Export
          </span>
        </download-excel>
      </base-button>
    </div>
    <div class="mt-5">
      <b-input-group class="">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
          v-on:input="searchBy"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="tableData"
        border
      >
        <el-table-column
          label="Event"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <!-- <template v-slot=""> -->
            <p>{{ row.eventID.title }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="First Name"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ row.firstName }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Last Name"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ row.lastName }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Phone Number"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ row.phone }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Email ID"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ row.email }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="How did you hear about the event"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ row.eventReference }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Other References"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ row.othersReference }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="Created"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p>{{ getDate(row.createdAt) }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-5 flex justify-end">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getffcPodcastData();
          }
        "
        layout="prev,pager,next"
        :per-size="10"
        :total="pageCount"
      >
      </el-pagination>
    </div>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import moment from "moment";
export default {
  data() {
    return {
      drawer: false,
      direction: "rtl",

      search: "",
      tableData: [],
      allData: [],

      // pagination
      currentPage: 1,
      pageCount: 0,
    };
  },
  computed: {
    json_fields() {
      return {
        "First Name": "firstName",
        "Last Name": "lastName",
        Phone: "phone",
        Email: "email",

        "How did you hear about the event": "eventReference",
        "Others Reference": "othersReference",

        "Created At": {
          field: "createdAt",
          callback: (date) => {
            return this.getDate(date);
          },
        },
      };
    },
  },
  methods: {
    searchBy: _.debounce(function (e) {
      this.getffcPodcastData();
    }, 500),

    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async getAllData() {
      let result = await this.$store.dispatch("ffc/getEventReg");
      console.log(result, "RESULT1");
      this.allData = result.data.data;
      return result.data.data;
    },
    async getffcPodcastData() {
      let offset = 0;
      let payload = {
        pagination: true,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      let result = await this.$store.dispatch("ffc/getEventReg", payload);
      console.log(result, "RESULT");
      this.tableData = result.data.data;
      this.pageCount = result.data.count;
    },
    downloadExcel() {
      import("./components/Export2Excel").then((excel) => {
        const list = this.allData.map((x) => {
          return {
            "First Name": x.firstName,
            "Last Name": x.lastName,
            Email: x.email,
            Phone: x.phone,

            "How did you hear about the event": x.eventReference,
            "Others Reference": x.othersReference,
          };
        });

        const headers = [
          "First Name",
          "Last Name",
          "Email",
          "How did you hear about the event",
          "Others Reference",
        ];
        const data = this.formatJson(headers, list);
        excel.export_json_to_excel({
          header: headers,
          data,
          filename: "Event Registyration",
          autoWidth: true,
          bookType: "csv",
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((i) =>
        filterVal.map((j) => {
          return i[j];
        })
      );
    },
  },
  async mounted() {
    await this.getAllData();
    await this.getffcPodcastData();
  },
  components: {
    FileUploader,
  },
};
</script>
